import styled from 'styled-components';
import { SliderLabelMixin } from '../../mixins/components/SliderLabelMixin';
/**
 * Used by the [`Slider`](#/Form%20components?id=slider) component to label the slider thumb.
 *
 * @since 6.12.0
 */

var SliderLabel = /*#__PURE__*/styled.div.withConfig({
  displayName: "SliderLabel",
  componentId: "c11n-8-64-0__sc-1ffi7el-0"
})(["", ""], SliderLabelMixin);
/** @component */

export default SliderLabel;
export var StyledSliderLabel = SliderLabel;